import { all } from '@/store/module/competition/getter/all.js';
import { eventTypes } from '@/store/module/competition/getter/eventTypes.js';
import { getById } from '@/store/module/competition/getter/getById.js';
import { getByName } from '@/store/module/competition/getter/getByName.js';

export const getters = {
	all,
	eventTypes,
	getById,
	getByName,
};
